export default {
  methods: {
    $parse() {
      let permissions = this.$store.state.auth.permissions;
      return (typeof permissions === 'string') ? JSON.parse(permissions) : permissions;
    },
    $can(permissionName) {
      if(this.$store.state.auth.currentUser === null){
        return false;
      }
      const permissions = this.$store.state.auth.permissions;
      permissionName = Array.isArray(permissionName) ? permissionName : [permissionName];

      return permissionName.some(permission => {
        return permissions.indexOf(permission) !== -1;
      });
    },
    // $validate(permissionsArray) {
    //   let permissions = this.$parse();
    //   return permissionsArray.length == 0 ? true : permissionsArray.some(p => permissions.includes(p));
    // },
    // $exists(permissionName) {
    //   let permissions = this.$parse();
    //   return permissions.includes(permissionName);
    // }
  },
};